import React from 'react';
import {PageLayoutTwoCol} from 'layout/components';
import {LearningPathsContent, LearningPathsSidebar} from './components';

export const LearningPathsViewAll = () => {
  return <PageLayoutTwoCol sidebar={<LearningPathsSidebar />} content={<LearningPathsContent />} />;
};
